import Icon from '@rio-cloud/rio-uikit/components/icon/Icon';
import React, { ElementType, Fragment, ReactElement, ReactNode, useState } from 'react';
import { useIntl } from 'react-intl';

interface LimitedListProps {
  children: ReactNode;
  elementType?: ElementType;
  start?: number;
  urlsContained?: number;
}

const SHOULD_COLLAPSE_THERESHOLD = 3; // INFO: Number of items from which the list should be collapsed
const MAX_ITEMS_COLLAPSED = 3; // INFO: Number of items to be displayed when the list is collapsed

const LimitedList = ({
  children,
  elementType = 'ul',
  start = 1,
  urlsContained = 0,
}: LimitedListProps): ReactElement => {
  const intl = useIntl();
  const items = React.Children.toArray(children).filter((item) => item !== '\n');
  const [showAll, setShowAll] = useState(urlsContained <= SHOULD_COLLAPSE_THERESHOLD);
  const shouldShowMoreButton = urlsContained > SHOULD_COLLAPSE_THERESHOLD;

  const displayedItems = showAll ? items : items.slice(0, MAX_ITEMS_COLLAPSED);

  return (
    <Fragment>
      {elementType === 'ul' ? (
        <ul className="margin-top-0">{displayedItems}</ul>
      ) : (
        <ol className="margin-top-0" start={start}>
          {displayedItems}
        </ol>
      )}

      {shouldShowMoreButton && (
        <button type="button" onClick={() => setShowAll((prev) => !prev)} className="btn btn-link padding-y-5">
          {intl.formatMessage({ id: showAll ? 'common.showLess.toggle' : 'common.showMore.toggle' })}
          <Icon className="padding-5" iconName={showAll ? 'icon-chevron-up' : 'icon-chevron-down'} />
        </button>
      )}
    </Fragment>
  );
};

export default LimitedList;
